import { reduce, isEmpty, groupBy, map, last, toPairs, prop, path, find, propEq, assocPath, equals } from 'ramda'

import { DataBox } from 'app/common/data-box-store'
import toFixedValue from 'app/common/lib/toFixedValue'

import { CampSelector } from 'app/dataTypes/CampSelector'


type CampInfoData = {
  balance: number,
  deleted: boolean,
  id: number,
  school_id: number,
  school_title: string,
  title: string,
}

type SomeData = {
  id: string | number,
  camps: Array<CampInfoData>
}

class CampSelectorDataBox extends DataBox<CampSelector> {
  previosData: any = null

  initFromStudents = (someData: Array<SomeData>) => {
    const data = reduce<SomeData, CampSelector>((acc, { id, camps }) => {
      if (camps && !isEmpty(camps)) {
        const groupedBySchool = groupBy(({ school_id: tid }) => String(tid), camps)
        const groupedBySchoolPairs = toPairs(groupedBySchool)
        const all = map(([schoolId, sameSchoolItems]) => {
          const balanceValue = prop('balance', last(sameSchoolItems))
          return ({
            id: schoolId,
            title: (last(sameSchoolItems) || { title: '' }).title,
            schoolTitle: (last(sameSchoolItems) || { school_title: '' }).school_title,
            balance: typeof balanceValue === 'number' ? toFixedValue(balanceValue) : '???',
          })
        }, groupedBySchoolPairs)

        const lastEl = last(all)

        if (lastEl) {
          acc[id] = {
            allCamps: all,
            current: lastEl,
          }
        }
      }
      return acc
    }, {} as CampSelector, someData)

    if (!equals(this.previosData, data)) {
      this.updateData(() => data)
    }
    this.previosData = data
  }

  getCurrentByStudentId = (studentId: string) => {
    const studentData = this.data[studentId]
    if (studentData) return studentData.current
    return null
  }

  getAllCampsByStudentId = (studentId: string) => {
    const studentData = this.data[studentId]
    if (studentData) return studentData.allCamps
    return null
  }

  setCurrent = (studentId: string, id: string) => {
    this.updateData((currentData) => {
      const all = path([studentId, 'allCamps'], currentData) || []
      const currentCamp = find(propEq('id', id), all)
      if (currentCamp) {
        const res = assocPath([studentId, 'current'], currentCamp, currentData)
        return res
      }
      return currentData
    })
  }
}

export const campSelector = new CampSelectorDataBox('campSelector', {})
